'use es6';

export default ((decorators = []) => Component => decorators.reduceRight((Decorated, decorator) => decorator(Decorated), Component));